export const name = 'builderComponent' as const
// Feature-local alias retained for `createSideEffectsImplementor`; all migrated features re-export the
// same canonical conversion experiment from `@wix/thunderbolt-symbols`.
export { VSM_EDITOR_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'
// Viewer: each page container carries its own builder components instead of the site config carrying all of them.
export const builderComponentsPageScopingExperiment = 'builderComponentsPageScoping' as const
export const BuilderComponentsCatalogSymbol = Symbol('BuilderComponentsCatalog')
export const BuilderComponentLoaderSymbol = Symbol('BuilderComponentLoader')
export const BuilderComponentRegistrarSymbol = Symbol('BuilderComponentRegistrar')
export const BuilderComponentStyleApiSymbol = Symbol('BuilderComponentStyleApi')
export const BuilderComponentResolverSymbol = Symbol('BuilderComponentResolver')
export const BuilderComponentWarmupDataEnricherSymbol = Symbol('BuilderComponentWarmupDataEnricher')
export const BuilderResourcesManagerSymbol = Symbol('BuilderResourcesManager')
export const CompTypeToAllDescendantsHandlerSymbol = Symbol('CompTypeToAllDescendantsHandler')
